document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-es-product-buy-now]') : null;
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;
  const form = button.closest('form');
  if (!(form instanceof HTMLFormElement)) return;
  event.preventDefault();
  event.stopPropagation();
  if (form.dataset.esBuying === 'true' || !form.reportValidity()) return;
  const variant = form.elements.namedItem('id');
  const error = form.querySelector('.es-product-buy-now-error');
  if (!(variant instanceof HTMLInputElement) || !variant.value || variant.disabled) {
    if (error) { error.textContent = button.dataset.chooseSize; error.hidden = false; }
    return;
  }
  const originalText = button.textContent;
  const root = window.Shopify?.routes?.root || '/';
  form.dataset.esBuying = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = button.dataset.loadingText;
  if (error) { error.hidden = true; error.textContent = ''; }
  try {
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json' }, body: new FormData(form)
    });
    if (!response.ok) {
      const result = await response.json().catch(() => ({}));
      throw new Error(result.description || button.dataset.errorText);
    }
    window.location.assign(root + 'checkout');
  } catch (failure) {
    if (error) { error.textContent = failure.message || button.dataset.errorText; error.hidden = false; }
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = originalText;
    delete form.dataset.esBuying;
  }
});
